import classNames from "classnames";
import { LocalTime } from "@js-joda/core";
import React from "react";
import { formatTimes } from "../utils/dateUtils";
import { HashSet } from "../utils/HashSet";
import { CheckedVisitData } from "./AvailableVisitActivity";
import AvailableWeeklyTemplateShiftItem from "./AvailableWeeklyTemplateShiftItem";
import { AppList, AppListItem } from "./Generic/AppList";
import { CheckedOnboardingVisitData } from "./OnboardingVisitActivity";

interface Props {
  dayOfWeek: {
    key: string;
    displayDay: string;
    shifts: {
      startAt: LocalTime;
      endAt: LocalTime;
    }[];
    visitInstancesCount: number;
  };
  isMultiShift: boolean;
  checkedPatterns: HashSet<string>;
  requestedVisitBatch: boolean;
  onCheckVisit:
    | ((visitData: CheckedVisitData) => void)
    | ((visitData: CheckedOnboardingVisitData) => void);
}

const AvailableWeeklyTemplateShift = (props: Props) => {
  return (
    <AppListItem
      key={props.dayOfWeek.key}
      className={classNames({
        "disabled-day-in-pattern": props.dayOfWeek.visitInstancesCount === 0,
      })}
      leading={
        <AvailableWeeklyTemplateShiftItem
          dayOfWeek={props.dayOfWeek}
          isMultiShift={props.isMultiShift}
          checkedPatterns={props.checkedPatterns}
          requestedVisitBatch={props.requestedVisitBatch}
          onCheckVisit={props.onCheckVisit}
        />
      }
      title={props.dayOfWeek.displayDay}
      trailing={
        props.dayOfWeek.shifts.length === 1 ? <>{formatTimes(props.dayOfWeek.shifts[0])}</> : null
      }
      extra={
        props.dayOfWeek.shifts.length > 1 ? (
          <AppList density="densed">
            {props.dayOfWeek.shifts.map((shift, i) => (
              <AppListItem key={i} soft={true} title={""} trailing={formatTimes(shift)} />
            ))}
          </AppList>
        ) : null
      }
    />
  );
};

export default AvailableWeeklyTemplateShift;
